import { useSnackbar } from 'notistack';

function useNotification() {

    const { enqueueSnackbar } = useSnackbar();
    const notify = (message: string, type: 'default' | 'error' | 'success' | 'warning' | 'info' = 'default') => {
        console.log(message, type);
        return enqueueSnackbar(message, {
            variant: type,
            persist: false,
            autoHideDuration: 7000,
        })
    };
    return notify;
}

export default useNotification;